<template>
  <div
    data-flyout
    class="overflow-y-auto absolute bottom-0 inset-x-0 bg-white py-4 pb-0 border-t md:relative md:left-auto md:right-auto md:bottom-auto md:flex md:flex-col md:overflow-auto md:flex-grow transition-transform z-50"
    :class="classList"
    style="max-height: 85svh"
  >
    <div class="flex ml-4 mb-2 justify-between items-center">
      <div class="flex">
        <div class="md:hidden content-center" v-if="icon">
          <vue-feather :type="icon" data-icon ></vue-feather>
        </div>
        <div class="md:hidden content-center" v-else>
          <slot name="iconSvg" />
        </div>
        <h2
          data-heading
          class="font-bold ml-2"
          tabindex="0"
        >
          {{ heading }}
        </h2>
      </div>
      <div class="mr-4 cursor-pointer md:hidden content-center"
         data-close-icon
         @click="handleClose">
      <vue-feather type="x"
                   class="w-5 h-5"></vue-feather>
    </div>
  </div>
    <div>
      <div class="overflow-auto pt-2 w-full md:flex-wrap md:py-0 md:overflow-visible"
           role="listbox">
        <slot />
      </div>
    </div>
    <slot name="secondary" />
  </div>
</template>

<script>
import VueFeather from 'vue-feather';
/**
 * Flyout.vue
 */
export default {
  components: {
    VueFeather
  },
  props: {
    mobileActive: {
      type: Boolean,
      default: false,
    },

    active: {
      type: Boolean,
      default: false,
    },

    heading: {
      type: String,
      required: true,
    },

    icon: {
      type: String,
      required: false,
    },
  },

  data () {
    return {}
  },

  emits: ['close'],

  computed: {
    classList () {
      return [
        this.mobileActive ? '' : 'translate-y-100 md:translate-y-0',
        this.active ? '' : 'md:hidden',
      ]
    },
  },
  methods: {
    handleClose () {
      this.$emit('close')
    }
  }
}
</script>
